// Styling
import { StyledHeader, Logo, Title, LeftHeaderContainer, RightNav, StyledLink } from './styles'

// Assets
import AIRcloudWithTextIcon from '../../../assets/images/AIRcloudWithTextIcon.png';

interface HeaderProps {
  title: string;
}

export function Header({title}: HeaderProps) {
  return (
    <StyledHeader>
      <LeftHeaderContainer>
        <Logo
          src={AIRcloudWithTextIcon}
          className="img-fluid"
          alt="Logo"
        />
        <Title>{title}</Title>
      </LeftHeaderContainer>
      <RightNav>
        {/* <StyledLink to="/">Registration</StyledLink> */}
        <StyledLink to="/">Support Request</StyledLink>
      </RightNav>
    </StyledHeader>
  );
}
